/**
 * internal dependencies
 */
import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { VEHICLE_POOL_FORM } from '../form-cardgroup-types';
import { getParameters, generator } from '../../../../helpers/helpers';

import DisplayVehiclePins from './display-vehicle-pins';
import { newPinPoolWidget } from '../../../widgets/new-pin-pool-widget';
import { checkForUniquePin } from './vehicle-pin-helpers';

import GetCardGroupVehiclePin from '../../../../routes/get-vehicle-pins';

/**
 * function that gets individual card group information
 * 
 * @returns void
 */
const CardGroupVehiclePin = async () => {
  const groupID = getParameters('cardGroupID');

  const [ cardgroup ] = await Promise.all([
    GetCardGroupVehiclePin(groupID)
  ]);

  DisplayVehiclePins(cardgroup);

  PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
  DASHBOARD_CONTAINER.removeAttribute('style');  

  const gen = generator();
  const vpFieldContainer = VEHICLE_POOL_FORM.vpFieldContainer;

  VEHICLE_POOL_FORM.vpAddPinRecord.addEventListener('click', event => {
    event.preventDefault();
    const lastElement = document.querySelector('[data-pin-number]:last-child') as HTMLElement;
    const nextNum = lastElement ? String(parseInt(lastElement.dataset.pinNumber!) + 1) : String(gen.next().value);
    newPinPoolWidget(nextNum, vpFieldContainer);
    VEHICLE_POOL_FORM.vpExport.removeAttribute('disabled');
  });

  let timeout: any;
  vpFieldContainer.addEventListener('keyup', event => {    
      const input = event.target as HTMLInputElement;      
      if (input.classList.contains('pin_number')) {
        input.dataset.pin = input.value.trim();
        clearTimeout(timeout);
        timeout = setTimeout(() => {          
          checkForUniquePin(input);
        }, 300);
      }
  });
}; 

export default CardGroupVehiclePin;